import { useMemo } from 'react'

import { useFeatures, useUser } from 'hooks'

import { useOrganizationUsers } from './useOrganizationUsers'
import { UserTableData } from '../types'

export const useSettings = () => {
  const user = useUser()
  const { organizationFeatures } = useFeatures()

  const { invitations, users, loading: usersLoading } = useOrganizationUsers()

  const organization = useMemo(() => {
    return {
      id: user?.organizationRole?.organization.id,
      name: user?.organizationRole?.organization.name,
      logo: user?.organizationRole?.organization.logo ?? undefined,
      features: organizationFeatures,
    }
  }, [organizationFeatures, user])

  const usersCardData = useMemo(() => {
    if (!user || !users) return []

    const { allUsers, currentUser } = users.reduce(
      (usersData: { allUsers: UserTableData[]; currentUser?: UserTableData }, orgUser) => {
        const isCurrentUser = user.id === orgUser.id
        const userData: UserTableData = {
          id: orgUser.user.id,
          email: orgUser.user.email,
          fullname: `${orgUser.user.name} ${orgUser.user.lastName}`,
          role: orgUser.role,
          regionId: orgUser.regionId ?? undefined,
          profilePicture: orgUser.user.profilePicture ?? undefined,
          currentUser: isCurrentUser,
        }

        if (isCurrentUser) {
          // eslint-disable-next-line no-param-reassign
          usersData.currentUser = userData
          return usersData
        }
        usersData.allUsers.push(userData)
        return usersData
      },
      { allUsers: [] },
    )

    if (!currentUser) return []

    const invitedUsers: UserTableData[] =
      invitations?.map(invitedUser => ({
        id: invitedUser.id,
        email: invitedUser.email,
        fullname: 'Usuario sin cuenta en Kuna',
        role: invitedUser.role,
        regionId: invitedUser.regionId ?? undefined,
        isInvitation: true,
      })) ?? []

    return [currentUser, ...invitedUsers, ...allUsers]
  }, [invitations, user, users])

  return { organization, usersCardData, usersLoading }
}
